













































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Tenant from "@/store/entities/tenant";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeSelect from "@riophae/vue-treeselect";
import Moment from "moment-timezone";
@Component({
  components: { TreeSelect },
})
export default class EditTenant extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  tenant: Tenant = new Tenant();
  loading: boolean = false;
  save() {
    (this.$refs.tenantForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        let checkexit = await this.$store
          .dispatch({
            type: "tenant/checkexist",
            data: this.tenant,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        if (checkexit.data.result != null) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: checkexit.data.result,
          });
          this.loading = false;
          return;
        }
        await this.$store
          .dispatch({
            type: "tenant/update",
            data: this.tenant,
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.tenantForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.tenantForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.tenant = Util.extend(true, {}, this.$store.state.tenant.editTenant);
    }
  }
  //验证手机号
  validatePhone = (rule, value, callback) => {
    if (!value) {
      return callback(new Error("手机号不能为空"));
    } else if (!/^1[345789]\d{9}$/.test(value)) {
      callback("手机号格式不正确");
    } else {
      callback();
    }
  };
  tenantRule = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty", undefined, this.L("TenantName")),
        trigger: "blur",
      },
    ],
    tenancyName: [
      {
        required: true,
        message: this.L("TagCanNotBeEmpty", undefined, this.L("TenancyName")),
        trigger: "blur",
      },
    ],
    adminEmailAddress: [
      {
        required: true,
        message: this.L(
          "EmailCanNotBeEmpty",
          undefined,
          this.L("AdminEmailAddress")
        ),
        trigger: "blur",
      },
      { type: "email" },
    ],
    mobile: [
      {
        required: true,
        validator: this.validatePhone,
        trigger: "blur",
      },
    ],
    roleId: [
      {
        required: true,
        type: "number",
        message: this.L("FieldIsRequired", undefined, this.L("Role")),
        trigger: "blur",
      },
    ],
    cityId: [
      {
        required: true,
        type: "number",
        message: this.L("FieldIsRequired", undefined, this.L("City")),
        trigger: "blur",
      },
    ],
    connectionString: [
      {
        message: this.L(
          "FieldIsRequired",
          undefined,
          this.L("DatabaseConnectionString")
        ),
        trigger: "blur",
      },
    ],
    serverip: [
      {
        message: this.L("FieldIsRequired", undefined, this.L("Serverip")),
        trigger: "blur",
      },
    ],
    port: [
      {
        required: true,
        type: "number",
        message: this.L("FieldIsRequired", undefined, this.L("Port")),
        trigger: "blur",
      },
    ],
    dataBase: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("DataBase")),
        trigger: "blur",
      },
    ],
    uid: [
      {
        required: true,
        message: this.L("FieldIsRequired"),
        trigger: "blur",
      },
    ],
  };
  async itemtree() {
    await this.$store
      .dispatch("city/getCitySelectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async getrolelist() {
    await this.$store
      .dispatch("role/getAllRole")
      .then((val) => {
        this.$data.rolelist = [];
        val.forEach((ele) => {
          this.$data.rolelist.push({
            label: ele.name,
            value: ele.id,
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      optionsMechanism: [],
      rolelist: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      options2: {
        shortcuts: [
          {
            text: this.L("ThreeMonths"),
            value() {
              const time = new Date();
              return [
                Moment(time).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
                Moment(time)
                  .add(3, "month")
                  .add(-1, "day")
                  .endOf("day")
                  .format("YYYY-MM-DD HH:mm:ss"),
              ];
            },
          },
          {
            text: this.L("SixMonths"),
            value() {
              const end = new Date();
              return [
                Moment(end).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
                Moment(end)
                  .add(6, "month")
                  .add(-1, "day")
                  .endOf("day")
                  .format("YYYY-MM-DD HH:mm:ss"),
              ];
            },
          },
          {
            text: this.L("TwoYear"),
            value() {
              const end = new Date();
              return [
                Moment(end).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
                Moment(end)
                  .add(2, "years")
                  .add(-1, "day")
                  .endOf("day")
                  .format("YYYY-MM-DD HH:mm:ss"),
              ];
            },
          },
          {
            text: this.L("ThreeYear"),
            value() {
              const end = new Date();
              return [
                Moment(end).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
                Moment(end)
                  .add(3, "years")
                  .add(-1, "day")
                  .endOf("day")
                  .format("YYYY-MM-DD HH:mm:ss"),
              ];
            },
          },
          {
            text: this.L("FiveYear"),
            value() {
              const end = new Date();
              return [
                Moment(end).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
                Moment(end)
                  .add(5, "years")
                  .add(-1, "day")
                  .endOf("day")
                  .format("YYYY-MM-DD HH:mm:ss"),
              ];
            },
          },
        ],
      },
    };
  }
  created() {
    this.tenant.tenantType = 2;
    this.itemtree();
    this.getrolelist();
    this.tenant.startTime = Moment()
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.tenant.endTime = Moment()
      .add(1, "years")
      .add(-1, "days")
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
  }
}
